import * as React from 'react'

import './header.scss'

export interface Props {
	variation?: 'h1' | 'h2' | 'h3'
	children: React.ReactNode
	style?: React.CSSProperties
	affix?: React.ReactNode
}

const Header = ({ children, variation = 'h1', style, affix }: Props) => {
	const Element = variation
	return (
		<Element className="create-campaign-header text-info" style={style}>
			{children}
			{affix && (
				<>
					&nbsp;<span style={{ fontSize: '67%' }}>{affix}</span>
				</>
			)}
		</Element>
	)
}

export default Header
